import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { Genre } from "types/genre";

export const useGenres = () => {
  const [genres, setGenres] = React.useState<Genre[]>([]);
  const [fetching, setFetching] = React.useState(true);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    (async () => { await getGenres() })();
  }, []);

  const getGenres = async () => {
    try {
      setFetching(true);
      const response = await axios.get(
        `${API_BASE_URL}${API_URLS.Genres}`,
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      setGenres(response.data.data);
    } catch (e) {
      console.error(e);
    } finally {
      setFetching(false);
    }
  };

  return { genres, fetching };
};
